import { useState, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import NavLinkAdapter from './NavLinkAdapter';
import clsx from 'clsx';
import useThemeMediaQuery from '../../core/hooks/useThemeMediaQuery';
import { useGlobalCore } from '../../core/modules/global';

interface SubmenuItem {
  title: string;
  url: string;
  icon: ReactNode;
  external?: boolean;
}

interface Props {
  title: string;
  icon: ReactNode;
  submenu: SubmenuItem[];
}

const NavItemWithSubmenu = ({ title, icon, submenu }: Props) => {
  const [open, setOpen] = useState(false);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { closeMobileNarvar } = useGlobalCore();
  const location = useLocation();

  // Detectar si algún subitem está activo
  const isAnyChildActive = submenu.some(
    (item) => !item.external && location.pathname === item.url
  );

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleSubItemClick = () => {
    if (isMobile) {
      closeMobileNarvar();
    }
  };

  return (
    <>
      <ListItem
        component="button"
        onClick={handleClick}
        className={clsx('fuse-list-item')}
        sx={{
          backgroundColor: isAnyChildActive ? 'rgba(255,255,255,0.08)' : 'inherit',
          color: 'inherit'
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {submenu.map((item) =>
            item.external ? (
              <ListItem
                key={item.title}
                component="a"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className={clsx('fuse-list-item', 'submenu-item')}
                sx={{ pl: 4 }}
                onClick={handleSubItemClick}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItem>
            ) : (
              <ListItem
                key={item.title}
                component={NavLinkAdapter}
                to={item.url}
                activeClassName="active"
                className={clsx('fuse-list-item', 'submenu-item')}
                sx={{ pl: 4 }}
                role="button"
                onClick={handleSubItemClick}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItem>
            )
          )}
        </List>
      </Collapse>
    </>
  );
};

export default NavItemWithSubmenu; 